


































































































































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { StripeCreditCard } from "../types";
import { AxiosResponse } from "axios";

import ActivationNotice from "@/modules/subscriptions/components/ActivationNotice.vue";
import CancelledNotice from "@/modules/subscriptions/components/CancelledNotice.vue";
import CreditCardTable from "@/modules/subscriptions/components/CreditCardTable.vue";
import PaymentHistory from "@/modules/subscriptions/components/PaymentHistory.vue";
import AdditionalFeaturesPanel from "@/modules/subscriptions/components/AdditionalFeaturesPanel.vue";

const Subscription = namespace("subscriptions");
@Component({
  metaInfo() {
    return {
      title: "Orba One | Subscription",
    };
  },
  components: {
    "activation-notice": ActivationNotice,
    "credit-card-table": CreditCardTable,
    "payment-history": PaymentHistory,
    "cancelled-notice": CancelledNotice,
    "additional-features-panel": AdditionalFeaturesPanel,
  },
})
export default class Subscriptions extends Vue {
  @Subscription.Getter("getIsSandboxAccount") isSandbox: boolean;
  @Subscription.Getter("getMode") mode: number;
  @Subscription.Getter("getVerificationUsedQuota")
  verificationUsedQuota: number;
  @Subscription.Getter("getVerificationQuota") verificationQuota: number;
  @Subscription.Getter("getAmlUsedQuota")
  amlUsedQuota: number;
  @Subscription.Getter("getAmlQuota") amlQuota: number;
  @Subscription.Getter("getCurrentSubscriptionPlan")
  currentPlan: number;
  @Subscription.Getter("getPricePerVerification")
  pricePerVerification: number;
  @Subscription.Action("getCurrentVendorQuota")
  getCurrentVendorQuota!: () => Promise<AxiosResponse>;
  @Subscription.Action("cancelSubscription")
  cancelSubscription!: () => Promise<AxiosResponse>;
  @Subscription.Action("switchDefaultCard")
  switchDefaultCard!: (cardId: string) => Promise<AxiosResponse>;
  @Subscription.Action("getCurrentSubscriptionPlan")
  getCurrentSubscriptionPlan!: () => Promise<AxiosResponse>;

  isCancelled = false;

  convertToCurrency = (value) => {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
    return formatter.format(value);
  };

  beforeMount() {
    this.getCurrentSubscriptionPlan().then(() => {
      this.isCancelled = this.mode === 2;
    });
  }

  getScanCosts() {
    return this.convertToCurrency(this.amlUsedQuota * 1.75);
  }

  totalVerificationCost(): number {
    return this.pricePerVerification * this.verificationUsedQuota;
  }

  defaultCard: StripeCreditCard = {
    brand: "",
    cvcCheck: "",
    default: false,
    expireMonth: 0,
    expireYear: 0,
    fingerprint: "",
    id: "",
    last4: "",
    stripeId: "",
    vendorId: "",
  };
  created() {
    this.getCurrentSubscriptionPlan();
  }

  async switchCard(card: StripeCreditCard, showNotification = true) {
    this.defaultCard = card;
    const result = await this.switchDefaultCard(this.defaultCard.id);
    if (result.data) {
      const { last4 } = result.data.data;
      if (showNotification) {
        this.$notify({
          group: "success",
          title: "Default Card Changed",
          text: `The card ending ${last4} is now the default card.`,
        });
      }
    }
  }

  async confirmCancelPlan() {
    // this.cancelSubscription();
    this.$notify({
      group: "success",
      text: "Subscription Cancelled.",
    });
    await this.getCurrentSubscriptionPlan();
  }
}
